export default "__VITE_ASSET__ChWv2WWR__"